import CustomerReviews from '../CustomerReviews';
import './index.css';

const Review = () => (
  <div className="review-page">
    <h1>Leave us a review</h1>
    <div className="review-intro-card">
      <p>Hogcloud depends on your reviews to let others know how we can help them !  Leave your review today, and refer others to us</p>
    </div>
    <CustomerReviews scrollable />
  </div>
);

export default Review;
